import { render } from "./mental_health_imaging.vue?vue&type=template&id=66280736&scoped=true"
import script from "./mental_health_imaging.vue?vue&type=script&lang=js"
export * from "./mental_health_imaging.vue?vue&type=script&lang=js"

import "./mental_health_imaging.vue?vue&type=style&index=0&id=66280736&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66280736"]])

export default __exports__